module.exports = __webpack_public_path__ + "img/yinhelogo.ff3c35a9.png";